// extracted by mini-css-extract-plugin
export default {"container":"MultiselectSets_container__gH0p0","setImage":"MultiselectSets_setImage__MzCqh"};